import styled from 'styled-components';
export const ClearButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  background-color: var(--grey300);
  color: var(--grey700);
  gap: 8px;
  cursor: pointer;
  svg {
    width: 10px;
    height: 10px;
    path {
      fill: var(--white);
    }
  }
`;
